export default "__VITE_ASSET__D0XbLroK__"